import { defineMessage } from "react-intl";

export const LABEL_INATIVO = defineMessage({ defaultMessage: "(Inativo)" });
